module.exports = __webpack_public_path__ + "img/year.b4fc5533.svg";